export default () => ({
    selectedCategory: null,

    shouldBeVisible(categoryIds = []) {
        if (!this.selectedCategory) {
            return true
        }

        return categoryIds.includes(parseInt(this.selectedCategory))
    },
})
